export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-962d23f6f582385dc41ca433b01a4fbf.png";